import { AlertTriangle, CheckCircle2, Info, XCircle } from "lucide-react";
import { Toaster as Sonner } from "sonner";

/**
 * Notifications in the same frame as the in-page notices: white box, coloured
 * bar on the left, bold message. Replaces the library's rounded default.
 */
export function Toaster() {
  const base = "flex w-[min(380px,calc(100vw-1.5rem))] items-start gap-3 rounded-md border border-line border-l-[5px] bg-surface px-4 py-3 text-sm text-ink shadow-lg";
  return (
    <Sonner
      position="top-center"
      closeButton
      icons={{
        success: <CheckCircle2 className="size-5 text-ok" />,
        error: <XCircle className="size-5 text-bad" />,
        info: <Info className="size-5 text-info" />,
        warning: <AlertTriangle className="size-5 text-warn" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: base,
          title: "font-bold leading-relaxed",
          description: "mt-0.5 text-[13px] text-ink-2",
          success: "border-l-ok",
          error: "border-l-bad",
          info: "border-l-info",
          warning: "border-l-warn",
          icon: "mt-0.5 shrink-0",
          closeButton: "order-last ml-auto shrink-0 rounded p-0.5 text-muted hover:bg-ground hover:text-ink [&_svg]:size-4",
        },
      }}
    />
  );
}
